import { useEffect, useRef, useState } from "react";
import { acdCodes } from "../../utils/acdCodes";
import moment from "moment";
import { actions, basis, dueProcess, extent, stagingState, suffix } from "../../utils/withdrawalOptions";

import { useNavigate } from "react-router-dom";
import { buildAddWithdrawal, buildNegateStageWithdrawal, buildNegateWithdrawal, buildUpdateFcwdDriverInfo, buildUpdateWithdrawalDetails, buildWithdrawalDetails, ccContacts, defaultConvictions, defaultDriverData, defaultWithdrawals, errMessage, fcwdOnly, foreignData, isDown, isNewUser, makeWithdrawalObjectForAdd, postJson, setDefaultConvictions, setDefaultDriverData, toPascalCaseWithHyphens, toYMD } from "../../utils/data";
import { canadianProvinces, countryOptions } from "../../utils/countryOptions";
import { useAuth } from "../../context/AuthContext";
import { formatDOB } from "../consts/dateMask";
import Loading from "../tabs/loading";

function UpdateStageWithdrawal() {

    const {source, email, userState, token} = useAuth();
    const acdDetailsRef = useRef(null);
    const navigate = useNavigate();
    const [extentCode, setExtentCode] = useState("1");
    const [acdCode, setAcdCode] = useState("");
    const [selectedAcd, setSelectedAcd] = useState(null);
    const [selectedDueProcess, setDueProcess] = useState("2");
    const [indefPerm, setIndefPerm] = useState("");
    const [selectedBasis, setBasis] = useState("1");
    const [action, setAction] = useState("6");
    const [comments, setComments] = useState("Withdrawal Added");
    const [stateNative, setStateNative] = useState();
    const [locator, setLocator] = useState();
    const [reinstatementDate, setReinstatementDate] = useState("");
    const [eligibilityDate, setEligibilityDate] = useState("");
    const [effectiveDate, setEffectiveDate] = useState("");
    const [postedDate, setPostedDate] = useState("");
    const [linkId, setLinkId] = useState("");
    const [duration, setDuration] = useState("");
    const [notice, setNotice] = useState("");
    const [dqNeeded, setDqNeeded] = useState("2");
    const [dqSendDate, setDqSendDate] = useState("");
    const [dqMailDate, setDqMailDate] = useState("");
    const [jurisdiction, setJurisdiction] = useState("FH");
    const [daysYears, setDaysYears] = useState("days");
    const [validated, setValidated] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [inputValue, setInputValue] = useState("");
    const [maxVal , setMaxVal] = useState(0);
    const [err, setErr] = useState([]);
    const [loading, setLoading] = useState(false);
    const screenRef = useRef(null);
    const errRef = useRef(null);
    let originalReinDate = '';

    const userType = "DEFAULT"; // Replace with actual user state logic
    const dataSource = {DataSource: source, CAorMXDown: isDown, userId: email}

    const handleAcdChange = (e) => {
        const code = e.target.value; // Reset ACD Details input
        setAcdCode(code);
        console.log(`Selected ACD Code: ${code}`);
        if (acdDetailsRef.current) {
            acdDetailsRef.current.value = ""; // clear the input field
        }
        code === "S92" ? setMaxVal(5) : 
        code.startsWith("D") ? setMaxVal(3) :
        setMaxVal(2);
        const found = acdCodes.find(a => a.code === code);
        setSelectedAcd(found || null);
    }
    
    const updateEligibleEffectiveDates = () => {
        // If notice + daysYears present -> compute effective = today + notice (days or years)
        if (notice !== "") {
            const amt = Number(notice) || 0;
            // daysYears should be "days" or "years"
            const newEff = moment().add(amt, "days").format("YYYY-MM-DD");
            if (newEff !== effectiveDate){
                console.log("New Effective Date", newEff, effectiveDate);
                setEffectiveDate(newEff);
            }
        }

        // If duration + effectiveDate present -> compute eligibility = effectiveDate + duration days
        if (duration !== "" && effectiveDate && daysYears) {
            const days = Number(duration) || 0;
            const newElig = moment(effectiveDate, "YYYY-MM-DD").add(days, daysYears).format("YYYY-MM-DD");
            console.log("New Eligible Date", newElig);
            setEligibilityDate(newElig);
            return;
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            console.log(defaultWithdrawals);
            postJson('/api/stage/withdrawal/details', buildWithdrawalDetails({driver: defaultDriverData, withdrawalId: defaultWithdrawals[0], sourceOpts: dataSource}), null, token)
            .then(function(result){
                if (!result || !result.Withdrawals) {
                    console.error("Withdrawal data is missing. Routing back.");
                    navigate(-1); // Routes back to the previous page
                    return; // Stops further execution
                }
                setAcdCode(result.Withdrawals.DRVLicAcdWithdrawalReasonCode)
                const found = acdCodes.find(a => a.code === result.Withdrawals.DRVLicAcdWithdrawalReasonCode);
                setDefaultConvictions(result.Convictions);
                setSelectedAcd(found || null);
                setAction(result.Withdrawals.DriverLicenseWithdrawalType)
                setBasis(result.Withdrawals.DriverLicenseWithdrawalBasis)
                setDueProcess(result.Withdrawals.DLWithdrawalDueProcessStatus)
                setExtentCode(result.Withdrawals.DRVLicWithdrawalExtentIdDlc)
                setEffectiveDate(moment(result.Withdrawals.DriverLicenseWithdrawalEffectiveDate).format('YYYY-MM-DD'))
                setStateNative(result.Withdrawals.DRVLicWithdrawalReasonReference)
                setLocator(result.Withdrawals.DLWithdrawalJurisdictionReportId)
                setPostedDate(moment(result.Withdrawals.WithdrawalDatePosted).format('YYYY-MM-DD'))
                setLinkId(result.Withdrawals.DLWithdrawalIdConvictionLinksGroup)
                if(moment(result.Withdrawals.WithdrawalDisqLetterSentDate).isValid()){
                    setDqSendDate(moment(result.Withdrawals.WithdrawalDisqLetterSentDate).format('YYYY-MM-DD'))
                }
                if(moment(result.Withdrawals.DLWithdrawalReinstatementDate).isValid()){
                    console.log("Valid reinstatment date")
                    setReinstatementDate(moment(result.Withdrawals.DLWithdrawalReinstatementDate).format('YYYY-MM-DD'))
                    originalReinDate = moment(result.Withdrawals.DLWithdrawalReinstatementDate).format('YYYY-MM-DD')
                }
                if(moment(result.Withdrawals.DRVLicWithdrawalEligibilityDate).isValid()){
                    setEligibilityDate(moment(result.Withdrawals.DRVLicWithdrawalEligibilityDate).format('YYYY-MM-DD'))
                } else {
                    setIndefPerm(result.Withdrawals.DRVLicWithdrawalEligibilityDate.toLowerCase())
                }
                
            })
            .catch(function(error) {
                console.error("API Error: ", error);
                navigate(-1); 
            });
        }
        fetchData()}, []);

    const  handleCancel = (e) => {
        e.preventDefault();
        navigate(-1);
    }

    const disableKey  = (event) =>{ 
        event.preventDefault();
        const { name, value } = event.target;
        if(formatDOB(value)){
            return;
        }
    }

    const handleModalSubmit = async (e) => {
        e.preventDefault();
        const withdrawal = {DriverLicenseWithdrawalIdCode: defaultWithdrawals[0],
            JurisdictionCodeWithdrawing: jurisdiction !== '' ? jurisdiction: userState,
            WithdrawalUserId: email,
            DRVLicAcdWithdrawalReasonCode: acdCode,
        }
        const build = buildNegateStageWithdrawal({withdrawal: withdrawal, comment: inputValue, sourceOpts: dataSource});
        await postJson('/api/stage/withdrawal/negate', build, null, token)
        .then(function(response) {
            console.log("Response sent")
            if (response.Status === "SUCCESS"){
                setShowModal(false);
                navigate(-1);
            } else {
                setErr(response.Message)
            }
        })
        .catch(function(error) {
            setErr("Error submitting Withdrawal: "+error.message);
        });
    }

    const handleSubmit = async (e) => {
        setLoading(true);
        e.preventDefault();
        setErr("");
        const form = e.target;
        const submittedButton = e.nativeEvent.submitter;
        window.scrollTo(0, 0);

        if (submittedButton?.id !== "deleteStaged" && form.checkValidity() === false) {
        e.stopPropagation(); // prevent submit if invalid
        setLoading(false);
        } else {
                console.log("Submit in progress", reinstatementDate, eligibilityDate, indefPerm)
                let withdrawal = {};
                let build;
                console.error("Submitted Button:", submittedButton.id);
                switch(submittedButton.id){
                    case "saveStaged":
                        withdrawal = {
                            DriverLicenseWithdrawalIdCode: defaultWithdrawals[0],
                            DriverLicenseWithdrawalBasis: selectedBasis,
                            DLWithdrawalDueProcessStatus: selectedDueProcess,
                            DriverLicenseWithdrawalEffectiveDate: effectiveDate,
                            DRVLicWithdrawalEligibilityDate: indefPerm === '' ? eligibilityDate : indefPerm.toUpperCase(),
                            DLWithdrawalReinstatementDate: reinstatementDate,
                            DRVLicWithdrawalExtentIdDlc: extentCode,
                            WithdrawalDQLetterMailedDate: dqMailDate,
                        }
                        build = buildUpdateWithdrawalDetails({driver:defaultDriverData, withdrawal: withdrawal, sourceOpts: dataSource})
                        console.log("Have request for add Withdrawal", build);
                        await postJson('/api/stage/withdrawal/update', build, null, token)
                        .then(function(response) {
                            console.log("Response sent")
                            if (response.Message === "Withdrawal stage details updated"){
                                navigate(-1);
                            } else {
                                setErr(response.Message)
                            }
                        })
                        .catch(function(error) {
                            setErr("Error submitting Withdrawal: "+error.message);
                        });
                        break;
                    case "moveStaged":
                        if(dqMailDate === ""){
                            setErr("Disqualification Letter Mailed Date is Required to Move from Staging to Withdrawal.")
                            setLoading(false);
                            return;
                        } else {
                            withdrawal = {
                                JurisdictionCodeWithdrawing: jurisdiction !== '' ? jurisdiction: userState,
                                DriverLicenseWithdrawalEffectiveDate: effectiveDate,
                                DriverLicenseWithdrawalType: action,
                                DriverLicenseWithdrawalBasis: selectedBasis,
                                DLWithdrawalDueProcessStatus: selectedDueProcess,
                                DRVLicAcdWithdrawalReasonCode: acdCode,
                                DRVLicWithdrawalEligibilityDate: indefPerm === '' ? eligibilityDate : indefPerm.toUpperCase(),
                                DLWithdrawalReinstatementDate: reinstatementDate,
                                DRVLicWithdrawalExtentIdDlc: extentCode,
                                DLWithdrawalJurisdictionReportId: locator,
                                DRVLicWithdrawalReasonReference: stateNative,
                                WithdrawalCategory: "",
                                WithdrawalNoticePeriod: "",
                                WithdrawalDuration: "",
                                WithdrawalReinstLetterSentDate: reinstatementDate,
                                WithdrawalDisqLetterNeeded: dqNeeded,
                                WithdrawalDisqLetterSentDate: dqSendDate,
                                WithdrawalDQLetterMailedDate: dqMailDate,
                                WithdrawalStatusNotes: comments,
                                WithdrawalUserId: email,
                                WithdrawalDateReceived: moment().format("YYYYMMDD"),
                                WithdrawalDatePosted: moment().format("YYYYMMDD"),
                            }
                            console.log("Move to FCWD with waiting for request", withdrawal);
                            build = buildAddWithdrawal({driver: defaultDriverData, foreign: foreignData, convictions: defaultConvictions, withdrawal: withdrawal, sourceOpts: dataSource})
                            console.log("Have request for add Withdrawal", build);
                            await postJson('/api/withdrawal/add', build, null, token)
                            .then(function(response) {
                                console.log("Response sent")
                                if (response.Status === "SUCCESS"){
                                    // After successful move, negate the staged withdrawal
                                    const negateWithdrawal = {DriverLicenseWithdrawalIdCode: defaultWithdrawals[0],
                                        JurisdictionCodeWithdrawing: jurisdiction !== '' ? jurisdiction: userState,
                                        WithdrawalUserId: email,
                                        DRVLicAcdWithdrawalReasonCode: acdCode,
                                    };
                                    const negateBuild = buildNegateStageWithdrawal({withdrawal: negateWithdrawal, comment:'Automatic: Moved from Stage to Withdrawal', sourceOpts: dataSource});
                                    return postJson('/api/stage/withdrawal/negate', negateBuild, null, token);
                                } else {
                                    setErr(response.Messages[0]);
                                    throw new Error("Move failed"); // Prevent further execution
                                }
                            })
                            .then(function(negateResponse) {
                                console.log("Negate response sent");
                                if (negateResponse.Status === "SUCCESS"){
                                    navigate(-1);
                                } else {
                                    setErr(negateResponse.Message);
                                }
                            })
                            .catch(function(error) {
                                setErr("Error submitting Withdrawal: "+error.message);
                            });
                        }
                        break;
                    default:
                        setShowModal(true);
                        break;
                }
                // // todo: remove process- moved to lambda
                // if(submittedButton.id !== "deleteStaged" && originalReinDate !== reinstatementDate){
                //     if(reinstatementDate !== ''){
                //         const address = fcwdOnly ? `${defaultDriverData.street1} ${defaultDriverData.street2 || ''}`.trim() : (foreignData.street1 !== '' || foreignData.street2 !== '') ? `${foreignData.street1} ${foreignData.street2 || ''}`.trim() : `${defaultDriverData.street1} ${defaultDriverData.street2 || ''}`.trim();
                //         const {firstName, middleName, surName, suffix} = fcwdOnly ? defaultDriverData : foreignData;
                //         const state = fcwdOnly ? defaultDriverData.driverState : foreignData.driverState || defaultDriverData.driverState;
                //         // Build JSON for reinstatement letter
                //         const reinLetterJson = {
                //             TemplateType: 'reinstatementLetter.docx',
                //             showMXBlock: state === 'MX',
                //             showCABlock: canadianProvinces.some(prov => prov.code === state),
                //             Date: moment().format("MMMM DD, YYYY"),
                //             MXDate: moment().locale('es').format("DD [de] MMMM [de] YYYY"),
                //             FullName: `${toPascalCaseWithHyphens(firstName)} ${toPascalCaseWithHyphens(surName)} ${suffix || ''}`.trim(),
                //             LastName: toPascalCaseWithHyphens(surName),
                //             ST: state,
                //             DLN: fcwdOnly ? defaultDriverData.driverLicense : foreignData.driverLicense || defaultDriverData.driverLicense,
                //             Address: address,
                //             County: fcwdOnly ? defaultDriverData.county : foreignData.county || defaultDriverData.county,
                //             City: fcwdOnly ? defaultDriverData.city : foreignData.city || defaultDriverData.city,
                //             State: fcwdOnly ? defaultDriverData.state : foreignData.state || defaultDriverData.state,
                //             Country: fcwdOnly ? defaultDriverData.country : foreignData.country || defaultDriverData.country,
                //             ZipCode: fcwdOnly ? defaultDriverData.zip : foreignData.zip || defaultDriverData.zip,
                //             ReinstatementDate: moment(reinstatementDate).format("MM/DD/YYYY"),
                //             MXReinstatementDate: moment(reinstatementDate).locale('es').format("DD/MM/YYYY"),
                //         };
                //         await postJson('/api/generate/dqReinDocx', {

                //             letterJson: reinLetterJson,
                //             to: email,   // or driver email / agency email
                //             subject: `FMCSA Reinstatement Notice for a ${defaultDriverData.country} Driver`,
                //             bodyText: "Please see the attached FMCSA Reinstatement Notice.",
                //         })
                //         .then((response) => {
                //             console.log("Generated Letter Docx", response);
                //         })
                //         .catch((err) => {
                //             setLoading(false);
                //             setErr("Error sending letter docx: " + err);
                //         });
                //     }
                // }
            }
            setLoading(false);
            setValidated(true); 
    }
  
      return (
          <>
              <div className="App">
                <div style={{color:'red'}}>{err}</div>
                <div ref={screenRef}></div>
                <div>{errMessage}</div>
                {loading &&
                        <Loading />}
                  <h1>Manual Withdrawal [Update Stage Withdrawal]</h1>
                  <div id="table">
                      <form className={`needs-validation ${validated ? "was-validated" : ""}`} id="Index-form" noValidate onSubmit={handleSubmit}>
                          <div className="row">
                              <div className="col-md-5">
                                  <label className="form-label"><b>Driver State</b></label>
                                  <input className="form-control" type="text"
                                  value={defaultDriverData.driverState} disabled />
                              </div>
                              <div className="col-md-5">
                                  <label className="form-label"><b>Driver License</b></label>
                                  <input className="form-control" type="text"
                                  value={defaultDriverData.driverLicense} disabled />
                              </div>
                          </div>
                            <div className="row">
                                <div className="col-md-3">
                                    <label className="form-label"><b><span className="text-danger">*</span> Withdrawal Effective Date </b></label>
                                    <input type="date" className="form-control" 
                                        placeholder="MM/DD/YYYY" 
                                        name='effectiveDate' 
                                        max={moment().format("YYYYMMDD")}
                                        value={effectiveDate}
                                        onChange={(e) => setEffectiveDate(e.target.value)}
                                        required
                                            />
                                        <div className="invalid-feedback">Please enter an Effective Date</div>
                                </div>
                                {indefPerm !== null && indefPerm === "" ? 
                                    <div className="col-md-3">
                                    <label className="form-label"><b><span className="text-danger">*</span> Withdrawal Eligible Date</b></label>
                                        <input type="date" className="form-control"
                                            value={eligibilityDate}
                                            placeholder="MM/DD/YYYY" name='convictionDate' min={effectiveDate}
                                            onChange={(e) =>  setEligibilityDate(e.target.value)}
                                            required
                                        />
                                        <div className="invalid-feedback">Please enter a valid Eligible Date</div>
                                </div> :
                                <div className="col-md-3">
                                    <label className="form-label"><b>Withdrawal Eligible Date</b></label>
                                    <input type="date" className="form-control"
                                        onChange={(e) => (e.target.value)}
                                        placeholder="MM/DD/YYYY" name='convictionDate'
                                        
                                        readOnly />
                                    </div>}
                                
                                <div className="col-md-3">
                                    <label className="form-label"><b>Indef/Perm</b></label>
                                    <select className="form-select"
                                        value={indefPerm}
                                        onChange={(e) => setIndefPerm(e.target.value)}
                                    >
                                        <option value="">-- INDEF/PERM --</option>
                                        <option value="indef">INDEF</option>
                                        <option value="perm">PERM</option>
                                    </select>
                                </div>
                                
                                <div className="col-md-3">
                                        <label className="form-label"><b>Withdrawal Reinstated Date</b></label>
                                        <input type="date" className="form-control" 
                                            value={reinstatementDate}
                                            onChange={(e) => setReinstatementDate(e.target.value)}
                                            max={moment().format("YYYYMMDD")}
                                            placeholder="MM/DD/YYYY" name='convictionDate'/>
                                    </div>
                                </div>
                                <div className="row">
                                <div className="col-md-3">
                                    <label className="form-label"><b>Notice Period</b></label>
                                    <span>(numbers only)</span>
                                        {duration !== '' ? (
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={notice}
                                            onChange={(e) => setNotice(e.target.value)}
                                            name="notice"
                                            maxLength={3}
                                            disabled
                                        />
                                        ) : (
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={notice}
                                            onChange={(e) => setNotice(e.target.value)}
                                            name="notice"
                                            maxLength={3}
                                        />
                                        )}
                                </div>
                                <div className="col-md-5">
                                    <label className="form-label"><b>Duration for Eligible Date</b><span>(numbers only)</span></label>
                                    <div className="d-flex align-items-center">
                                    <input type="text" className="form-control"
                                            value={duration}
                                            style={{ maxWidth: '60%' }}
                                            onChange={(e) => setDuration(e.target.value)}
                                            name="notice" maxLength={3}  />
                                    <select
                                        className="form-select"
                                        value={daysYears}
                                        onChange={(e) => setDaysYears(e.target.value)}
                                        style={{ maxWidth: '40%' }}
                                        >
                                        <option value="">-- Days/Years --</option>
                                        <option value="days">Days</option>
                                        <option value="years">Years</option>
                                    </select>
                                    </div>
                                </div>
                                <div className="col-md-3 align-self-end">
                                <button type="button" class="btn btn-secondary" onClick={updateEligibleEffectiveDates}>Update Dates</button>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-3">
                                    <label className="form-label"><b><span className="text-danger">*</span> Action</b></label>
                                    <select className="form-select"
                                        value={action}
                                        onChange={(e) => setAction(e.target.value)}
                                            required disabled>
                                            <option value="" disabled>-- Action --</option>
                                        {actions[userType].map((opt) => (
                                            <option key={opt.code} value={opt.code}>
                                                {opt.label}
                                            </option>
                                        ))}
                                    </select>
                                    <div className="invalid-feedback">Please select an Action</div>
                                    </div>
                                <div className="col-md-3">
                                    <label className="form-label"><b><span className="text-danger">*</span> Basis</b></label>
                                    <select className="form-select"
                                        value={selectedBasis}
                                        onChange={(e) => setBasis(e.target.value)}
                                            required
                                            
                                    >
                                        <option value="" disabled>-- Basis --</option>
                                        {basis[userType].map((opt) => (
                                            <option key={opt.code} value={opt.code}>
                                                {opt.label}
                                            </option>
                                        ))}
                                    </select>
                                    <div className="invalid-feedback">Please select a Basis</div>
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label mt-2"><b><span className="text-danger">*</span> Withdrawal Jurisdiction</b></label>
                                    <select className="form-select"
                                        value={jurisdiction}
                                        onChange={(e) => setJurisdiction(e.target.value)}
                                        required
                                        
                                        >
                                            <option value="" disabled>-- Jurisdiction --</option>
                                            <option value="FH">FH</option>
                                            {stagingState.map((opt) => (
                                                <option key={opt.code} value={opt.code}>
                                                    {opt.code}
                                                </option> ))}
                                        </select>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    <label className="form-label"><b><span className="text-danger">*</span> Due Process Status</b></label>
                                    <select className="form-select"
                                        value={selectedDueProcess}
                                        onChange={(e) => setDueProcess(e.target.value)}
                                            required
                                            
                                    >
                                        <option value="" disabled>-- Due Process --</option>
                                        {dueProcess[userType].map((opt) => (
                                            <option key={opt.code} value={opt.code}>
                                                {opt.label}
                                            </option>
                                        ))}
                                    </select>
                                    <div className="invalid-feedback">Please select a Due Process Status</div>
                                </div>
                                
                                <div className="col-md-3">
                                    <label className="form-label"><b><span className="text-danger">*</span> ACD Code</b></label>
                                        <select className="form-select"
                                            value={acdCode}
                                            onChange={handleAcdChange}
                                            required
                                            disabled
                                        >
                                            <option value="" disabled>-- ACD Code --</option>
                                            {acdCodes.map((opt) => (
                                                <option key={opt.code} value={opt.code} title={opt.label}>
                                                    {opt.code} - {opt.simple}
                                                </option>
                                            ))}
                                        </select>
                                        <div className="invalid-feedback">Please select an ACD Code</div>
                                    </div>
                                <div className="col-md-3">
                                    <label className="form-label"><b><span className="text-danger">*</span> Extent Code</b></label>
                                    <select className="form-select"
                                        value={extentCode}
                                        onChange={(e) => setExtentCode(e.target.value)}
                                            required
                                            
                                    >
                                        <option value="" disabled>-- Extent Code --</option>
                                        {extent[userType].map((opt) => (
                                            <option key={opt.code} value={opt.code}>
                                                {opt.label}
                                            </option>
                                        ))}
                                    </select>
                                    <div className="invalid-feedback">Please select an Extent Code</div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <label className="form-label"><b><span className="text-danger">*</span> Withdrawal Locator Number</b></label>
                                    <input type="text" className="form-control" name="locator" 
                                    value={locator}
                                    onChange={(e) =>setLocator(e.target.value)}
                                    maxLength={18}  required disabled/>
                                    <div className="invalid-feedback">Please enter a Withdrawal Locator Number</div>
                                </div>
                                <div className="col">
                                    <label className="form-label"><b><span className="text-danger">*</span>Reason Ref Code</b></label>
                                    <input type="text" className="form-control" name="stateNative"
                                    value={stateNative}
                                    onChange={(e)=>setStateNative(e.target.value)}
                                    maxLength={8}  required disabled/>
                                    <div className="invalid-feedback">Please enter a Reason Ref Code</div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    <label className="form-label"><b>Needs Disqualification Letter</b></label>
                                    <select className="form-select"
                                        value={dqNeeded}
                                        onChange={(e) => setDqNeeded(e.target.value)}
                                        disabled
                                    >
                                        <option value="" disabled>-- Select --</option>
                                        <option value="1">1 - Yes</option>
                                        <option value="2">2 - No</option>
                                    </select>
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label"><b>Disqualification Letter Emailed</b></label>
                                    <input type="date" className="form-control" 
                                        placeholder="MM/DD/YYYY" 
                                        name='DQSendDate' 
                                        max={moment().format("YYYYMMDD")}
                                        onChange={(e) => setDqSendDate(e.target.value)}
                                        value={dqSendDate}
                                        disabled
                                        />
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label"><b>Disqualification Letter Mailed</b></label>
                                    <input type="date" className="form-control" 
                                        placeholder="MM/DD/YYYY" 
                                        name='DQSendDate' 
                                        max={moment().format("YYYYMMDD")}
                                        onChange={(e) => setDqMailDate(e.target.value)}
                                        value={dqMailDate}
                                        />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    <label className="form-label"><b>Withdrawal Posted Date</b></label>
                                    <input type="date" className="form-control" 
                                        placeholder="MM/DD/YYYY" 
                                        name='postedDate'            
                                        value={moment().format("YYYY-MM-DD")}
                                        disabled />
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label"><b>User ID</b></label>
                                    <input type="text" className="form-control"
                                    value={email}
                                    name="userId" disabled />
                                </div>
                            </div>
  
                          <button type="submit" id="saveStaged" className="btn btn-primary mt-3 m-2">
                            Save Staged Withdrawal
                          </button>
                          <button type="submit" id="moveStaged" className="btn btn-primary mt-3 m-2">
                            Move From Staging To Withdrawal
                          </button>
                          <button type="submit" id="deleteStaged" className="btn btn-primary mt-3 m-2">
                            Delete Staged Withdrawal
                          </button>
                          <button type="button" onClick={(e) => handleCancel(e)} 
                          className="btn btn-secondary mt-3 m-2">
                            Back to Details for DL:{defaultDriverData.driverLicense}
                          </button>
                      </form>
                  </div>
              </div>
              {/* Modal for Negate/Delete */}
              {showModal && (
                <div className="modal fade show d-block" tabIndex="-1" role="dialog">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                    <form onSubmit={(e) => handleModalSubmit(e)}>
                    <div className="modal-header">
                        <h5 className="modal-title">Comments for Negate/Delete of Staged Withdrawal</h5>
                        <button
                        type="button"
                        className="btn-close"
                        onClick={() => setShowModal(false)}
                        />
                    </div>
                    <div className="modal-body">
                        <div class="form-group">
                            <label for="message-text" class="col-form-label">Reason for Negate/Delete</label>
                            <input
                            type="text"
                            value={inputValue}
                            onChange={(e) => setInputValue(e.target.value)}
                            placeholder="Reason"
                            style={{ width: "100%", marginBottom: 12 }}
                            required
                            />
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => setShowModal(false)}
                        >
                        Cancel
                        </button>
                        <button
                        type="submit"
                        className="btn btn-danger"
                        >
                        Delete
                        </button>
                    </div>
                    </form>
                    </div>
                </div>
                </div>
            )}
              {/* Modal for ACD Info */}
              {selectedAcd && (
                  <div className="modal fade" id="acdInfoModal" tabIndex="-1" aria-labelledby="acdInfoModalLabel" aria-hidden="true">
                      <div className="modal-dialog">
                          <div className="modal-content">
                              <div className="modal-header">
                                  <h5 className="modal-title" id="acdInfoModalLabel">ACD Code Information</h5>
                                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                              </div>
                              <div className="modal-body">
                                  <p><strong>ACD Code:</strong> {selectedAcd.code}</p>
                                  <p><strong>Description:</strong> {selectedAcd.label}</p>
                                  {selectedAcd.validation && (
                                      <p><strong>Validation:</strong> {selectedAcd.validation}</p>
                                  )}
                                  {selectedAcd.moreInfo && (
                                      <p><strong>More Info:</strong> {selectedAcd.moreInfo}</p>
                                  )}
                              </div>
                              <div className="modal-footer">
                                  <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                              </div>
                          </div>
                      </div>
                  </div>
              )}
          </>
      );
}

export default UpdateStageWithdrawal;